export default __webpack_public_path__ + "static/media/InfoBlack.ee09f754.svg";